import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from '@atlaskit/form';
import { RadioGroup } from '@atlaskit/radio';
import { OptionsPropType } from '@atlaskit/radio/types';
import styled from 'styled-components';
import { messages } from '../messages';

export type OrganizationSelectorRadioGroupProps = {
  readonly organizations: string[];
  readonly onOrganizationChanged: (newOrganization: string | null) => void;
};

export const OrganizationSelectorRadioGroup = ({
  organizations,
  onOrganizationChanged
}: OrganizationSelectorRadioGroupProps) => {
  const getRadioOptions = (
    organizations: string[],
    fieldName: string
  ): OptionsPropType => {
    return organizations.map((organization) => {
      // HOT-101715 fixes
      return {
        name: fieldName,
        value: organization,
        label: organization
      };
    });
  };

  const fieldName = 'organization';
  const radioOptions = getRadioOptions(organizations, fieldName);
  const defaultValue = radioOptions[0].value;

  const [selectedOrganization, setSelectedOrganization] = useState<
    string | number | undefined | null
  >(defaultValue);

  const onValueChange: React.ChangeEventHandler<HTMLInputElement> = (
    event: React.ChangeEvent
  ) => {
    onOrganizationChanged(event.currentTarget.getAttribute('value'));
    // In our custom onChange handler, we need to manage the RadioGroup state in our component's state
    const newValue = event.currentTarget.getAttribute('value');
    const newOrganizationSelected = newValue;

    setSelectedOrganization(newOrganizationSelected);
  };

  return (
    <Wrapper>
      <Field
        name={fieldName}
        label={<FormattedMessage {...messages.selectAnOrganization} />}
        defaultValue={selectedOrganization}
      >
        {({ fieldProps }: { fieldProps: object }) => (
          <RadioGroup
            {...fieldProps}
            options={radioOptions}
            onChange={onValueChange}
          />
        )}
      </Field>
    </Wrapper>
  );
};

const Wrapper = styled.div`
label:not(:first-child) {
  padding-top: 4px; 
  padding-bottom: 4px;
`;
